import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { updateAdditionalInfoLoading: true, data: '', error: false };

export function updateAdditionalInfo(state = initialState, action) {
    
    switch (action.type) {
        case userProfileConstants.REQUEST_UPDATE_ADDITIONAL_INFO:
            return {
                updateAdditionalInfoLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_UPDATE_ADDITIONAL_INFO:
        swal({
            text: 'User Additional Profile Updated Successfully',
            type: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                updateAdditionalInfoLoading: false,
                data: action.updateAdditionalInfo,
                error: false
            };
        case userProfileConstants.UPDATE_ADDITIONAL_INFO_ERROR:
        swal({
            text: 'Error in updating user profile',
            type:'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
        })
            return {
                updateAdditionalInfoLoading: false,
                data: action.error,
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/updateAdditionalInfo.reducer.js